export default "__VITE_PUBLIC_ASSET__ac000215__"